import { useMemo } from 'react';
import { useActiveCyclesTabInteractor } from './interactor';
import { CyclesScreen } from '../../CyclesScreen/CyclesScreen';
import { CyclesWithoutScreen } from '../../CyclesWithoutScreen/CyclesWithoutScreen';
import { useAppSelector } from '../../../../../store/store';
import FaultedCyclesButton from '../../../../../components/FaultedCyclesButton/FaultedCyclesButton';

export const Active = () => {
  const { screens, onDeleteScreen } = useActiveCyclesTabInteractor();
  const { activeScreensCycles, activeScreenlessCycles } = useAppSelector((state) => state.cycles);
  const allActiveCycles = useMemo(
    () => [...(screens ?? []).flatMap((screen) => activeScreensCycles[screen.id] ?? []), ...activeScreenlessCycles],
    [screens, activeScreensCycles, activeScreenlessCycles],
  );

  return (
    <div className="c-cycles-by-status flex flex-auto flex-col gap-y-2">
      <FaultedCyclesButton cycles={allActiveCycles} />
      {screens && (
        <>
          {screens.map((screen) => (
            <div className="last:mb-4 md:last:mb-6 2xl:last:mb-9" key={screen.id}>
              <CyclesScreen name={screen.name} screenId={screen.id} onDeleteScreen={onDeleteScreen} criticalDeviation={screen.critical_deviation} />
            </div>
          ))}
        </>
      )}
      <CyclesWithoutScreen />
    </div>
  );
};
